import { createSlice } from "@reduxjs/toolkit";
import { editUser, getAllUsers } from "./userService";

const initialState = {
  allUsers: {
    isUsersLoading: null,
    isUsersSuccess: null,
    userMessage: null,
    pageCount: 0,
    users: [],
  },
  editedUser: {
    isEditingUser: null,
    isUserEdited: null,
    userEditedMsg: null,
  },
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // PENDING
    builder
      .addCase(getAllUsers.pending, (state) => {
        state.allUsers = {
          ...initialState.allUsers,
          isUsersLoading: true,
          userMessage: "Loading",
        };
      })

      // REJECTED
      .addCase(getAllUsers.rejected, (state, action) => {
        state.allUsers = {
          ...initialState.allUsers,
          isUsersLoading: false,
          isUsersSuccess: false,
          userMessage:
            action.payload || "Error occurred while fetching users",
        };
      })

      // FULFILLED
      .addCase(getAllUsers.fulfilled, (state, action) => {
        state.allUsers = {
          ...initialState.allUsers,
          isUsersLoading: false,
          isUsersSuccess: true,
          pageCount: action.payload.pageCount || 0,
          users: action.payload.data || [],
        };
      });

       //Lottery editing
    builder
    .addCase(editUser.pending, (state) => {
      state.editedUser = {
        ...initialState.editedUser, 
        isEditingUser: true,
        userEditedMsg: "Loading",
      };
    })

    // REJECTED
    .addCase(editUser.rejected, (state, action) => {
      state.editedUser = {
        ...initialState.editedUser, 
        isEditingUser: false,
        isUserEdited: false,
        userEditedMsg:
          action.payload || "Error occurred while editing the user.",
      };
    })

    // FULFILLED
    .addCase(editUser.fulfilled, (state, action) => {
      state.editedUser = {
        ...initialState.editedUser, 
        isEditingUser: false,
        isUserEdited: true,
        userEditedMsg: action.payload || "Successfully edited the user.",
      };
    });
  },
});

export default userSlice.reducer;
